(() => {
  const colours = [
    '#ff776e', // red
    '#ffab58', // orange
    '#ffe16b', // yellow
    '#83d779', // green
    '#80b5ff', // blue
    '#aaa0f1', // indigo
    '#d28ff1', // violet
  ];

  // Give each button a hidden starting colour; choose again on every hover.
  for (let index = colours.length - 1; index > 0; index -= 1) {
    const swap = Math.floor(Math.random() * (index + 1));
    [colours[index], colours[swap]] = [colours[swap], colours[index]];
  }

  let nextColour = 0;

  const chooseColour = (button) => {
    const last = button.dataset.wmRainbowLast;
    let selected = Math.floor(Math.random() * (last === undefined ? colours.length : colours.length - 1));
    if (last !== undefined && selected >= Number(last)) selected += 1;
    button.style.setProperty('--wm-rainbow-color', colours[selected]);
    button.dataset.wmRainbowLast = String(selected);
  };

  const init = (root) => {
    root.querySelectorAll('[data-wm-rainbow-button]').forEach((button) => {
      if (button.classList.contains('wm-rainbow-ready')) return;
      button.style.setProperty('--wm-rainbow-color', colours[nextColour % colours.length]);
      button.classList.add('wm-rainbow-ready');
      button.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'touch' && !button.disabled) chooseColour(button);
      });
      button.addEventListener('focus', () => {
        if (!button.matches(':hover') && !button.disabled) chooseColour(button);
      });
      nextColour += 1;
    });
  };

  const start = () => init(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('wagmade:section-content-ready', (event) => init(event.target));
})();
